function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ulw59t1sba",
  x2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff0660"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.099,
  stopColor: "#ff0660"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.305,
  stopColor: "#742ddb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#54b8f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00003f"
})));

function SvgDailyStreak7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 452.002,
    height: 28,
    viewBox: "0 0 452.002 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(146 2)",
    style: {
      fill: "#000040",
      stroke: "#000040",
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242 2)",
    style: {
      fill: "#000040",
      stroke: "#000040",
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98 2)",
    style: {
      fill: "#000040",
      stroke: "#000040",
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194 2)",
    style: {
      fill: "#000040",
      stroke: "#000040",
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13310-15198a10 10 0 0 1 10-10 10 10 0 0 1 10 10 10 10 0 0 1-10 10 10 10 0 0 1-10-10zm2 0a8.01 8.01 0 0 0 8 8 8.008 8.008 0 0 0 8-8 8.008 8.008 0 0 0-8-8 8.01 8.01 0 0 0-8 8zm-55 0a10 10 0 0 1 10-10 10 10 0 0 1 10 10 10 10 0 0 1-10 10 10 10 0 0 1-10-10zm2 0a8.008 8.008 0 0 0 8 8 8.008 8.008 0 0 0 8-8 8.008 8.008 0 0 0-8-8 8.008 8.008 0 0 0-8 8zm-55 0a10 10 0 0 1 10-10 10 10 0 0 1 10 10 10 10 0 0 1-10 10 10 10 0 0 1-10-10zm2 0a8.007 8.007 0 0 0 8 8 8.01 8.01 0 0 0 8-8 8.01 8.01 0 0 0-8-8 8.007 8.007 0 0 0-8 8zm-55 0a10 10 0 0 1 10-10 10 10 0 0 1 10 10 10 10 0 0 1-10 10 10 10 0 0 1-10-10zm-47.949 1h-28.1a10 10 0 0 1-9.95 9 10 10 0 0 1-9.95-9h-28.1a10 10 0 0 1-9.954 9 10 10 0 0 1-9.95-9h-28.1a10 10 0 0 1-9.95 9 10 10 0 0 1-9.95-9h-28.1a10 10 0 0 1-9.95 9 10 10 0 0 1-10-10 10 10 0 0 1 10-10 10 10 0 0 1 9.95 9h28.1a10 10 0 0 1 9.95-9 10 10 0 0 1 9.95 9h28.1a10 10 0 0 1 9.95-9 10 10 0 0 1 9.954 9h28.1a10 10 0 0 1 9.95-9 10 10 0 0 1 9.95 9h28.1a10 10 0 0 1 9.95-9 10 10 0 0 1 9.95 9h20.3a6.446 6.446 0 0 1 1.273.121 1 1 0 0 1 .479-.121h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-3a1 1 0 0 1-.479-.121 6.446 6.446 0 0 1-1.273.121h-20.3a10 10 0 0 1-9.95 9 10 10 0 0 1-9.951-9zm251.952 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1zm-10 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1zm-10 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1zm-33 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1zm-10 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1zm-10 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1zm-33 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1zm-10 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1zm-10 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1zm-33 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1zm-10 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1zm-10 0a1 1 0 0 1-1-1 1 1 0 0 1 1-1h3a1 1 0 0 1 1 1 1 1 0 0 1-1 1z",
    transform: "translate(-12907 15212)",
    style: {
      fill: "url(#ulw59t1sba)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.024 18a1.029 1.029 0 0 1-.852-.466l-2.153-2.619a.973.973 0 0 1-.237-.624.807.807 0 0 1 .8-.817.85.85 0 0 1 .712.387l1.7 2.153 3.639-5.818a.822.822 0 0 1 .712-.457.8.8 0 0 1 .835.765 1.234 1.234 0 0 1-.229.615l-4.118 6.411a.965.965 0 0 1-.809.47z",
    transform: "translate(-1)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.024 18a1.029 1.029 0 0 1-.852-.466l-2.153-2.619a.973.973 0 0 1-.237-.624.807.807 0 0 1 .8-.817.85.85 0 0 1 .712.387l1.7 2.153 3.639-5.818a.822.822 0 0 1 .712-.457.8.8 0 0 1 .835.765 1.234 1.234 0 0 1-.229.615l-4.118 6.411a.965.965 0 0 1-.809.47z",
    transform: "translate(47)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.024 18a1.029 1.029 0 0 1-.852-.466l-2.153-2.619a.973.973 0 0 1-.237-.624.807.807 0 0 1 .8-.817.85.85 0 0 1 .712.387l1.7 2.153 3.639-5.818a.822.822 0 0 1 .712-.457.8.8 0 0 1 .835.765 1.234 1.234 0 0 1-.229.615l-4.118 6.411a.965.965 0 0 1-.809.47z",
    transform: "translate(95)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.024 18a1.029 1.029 0 0 1-.852-.466l-2.153-2.619a.973.973 0 0 1-.237-.624.807.807 0 0 1 .8-.817.85.85 0 0 1 .712.387l1.7 2.153 3.639-5.818a.822.822 0 0 1 .712-.457.8.8 0 0 1 .835.765 1.234 1.234 0 0 1-.229.615l-4.118 6.411a.965.965 0 0 1-.809.47z",
    transform: "translate(95)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.024 18a1.029 1.029 0 0 1-.852-.466l-2.153-2.619a.973.973 0 0 1-.237-.624.807.807 0 0 1 .8-.817.85.85 0 0 1 .712.387l1.7 2.153 3.639-5.818a.822.822 0 0 1 .712-.457.8.8 0 0 1 .835.765 1.234 1.234 0 0 1-.229.615l-4.118 6.411a.965.965 0 0 1-.809.47z",
    transform: "translate(143)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.024 18a1.029 1.029 0 0 1-.852-.466l-2.153-2.619a.973.973 0 0 1-.237-.624.807.807 0 0 1 .8-.817.85.85 0 0 1 .712.387l1.7 2.153 3.639-5.818a.822.822 0 0 1 .712-.457.8.8 0 0 1 .835.765 1.234 1.234 0 0 1-.229.615l-4.118 6.411a.965.965 0 0 1-.809.47z",
    transform: "translate(191)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.024 18a1.029 1.029 0 0 1-.852-.466l-2.153-2.619a.973.973 0 0 1-.237-.624.807.807 0 0 1 .8-.817.85.85 0 0 1 .712.387l1.7 2.153 3.639-5.818a.822.822 0 0 1 .712-.457.8.8 0 0 1 .835.765 1.234 1.234 0 0 1-.229.615l-4.118 6.411a.965.965 0 0 1-.809.47z",
    transform: "translate(239)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyStreak7);
export default __webpack_public_path__ + "static/media/daily-streak-7.62b351c6.svg";
export { ForwardRef as ReactComponent };